"use client";
import Link from "next/link";

interface IPostsData {
  title?: string;
  imgUrl?: string;
  href?: string;
  desc?: string;
  className?: string;
  SlideWidth?: string;
  style?: any;
}

export default function SingleRecentPost(props: IPostsData) {
  const { title = "", imgUrl = "", className = "", SlideWidth, href="" } = props;
  return (
    <Link className="text-left" href={href}>
      <figure className="rounded-xl overflow-hidden h-56 w-full lg:mb-4 mb-3 ${className}">
      <img loading="lazy" className="w-full h-full object-cover" src={imgUrl} alt="Feature Image" />
      </figure>
      <h3 className="text-primary-800 xl:text-2xl lg:text-xl text-lg  ">{title}</h3>
    </Link>
  );
}
